export function getAll() {
  return [
    {
      value: 0,
      name: "Normal",
      text: "一般",
    },
    {
      value: 1,
      name: "AdvancedDeposit",
      text: "訂金",
    },
    {
      value: 2,
      name: "FinalPayment",
      text: "尾款",
    },
    {
      value: 3,
      name: "PickUp",
      text: "取貨",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
